import { render, staticRenderFns } from "./OrderCreate.vue?vue&type=template&id=0f97a306&"
import script from "./OrderCreate.vue?vue&type=script&lang=js&"
export * from "./OrderCreate.vue?vue&type=script&lang=js&"
import style0 from "./OrderCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports